// import "./SkeletonLoadingDataGridStyle.css";

// import React, { useState } from "react";

// import { Column } from "primereact/column";
// import { DataTable } from "primereact/datatable";
// import { Skeleton } from "primereact/skeleton";
// import { useTheme } from "@mui/material";

// export interface IDataTable {
// 	rows: any;
// 	columns: any;
// 	showIndexColumn: boolean;
// 	showChecboxColumn: boolean;
// 	showSettingColumn: boolean;
// 	pageTitle?: string;
// }

// export const SkeletonLoadingDataGrid: React.FC<IDataTable> = ({
// 	rows,
// 	columns,
// 	showIndexColumn,
// 	showChecboxColumn,
// 	showSettingColumn,
// 	pageTitle
// }) => {
// 	const [loading, setLoading] = useState(false);
// 	const theme = useTheme();
// 	const renderHeader = () => {
// 		return (
// 			<div
// 				style={{
// 					display: "flex",
// 					// justifyContent:showGlobalSearch ? "space-between" : "end",
// 					justifyContent: "space-between",
// 					alignItems: "center",
// 				}}
// 			>
// 				<div
// 					style={{
// 						fontSize: "1.5rem",
// 						fontWeight: "bold",
// 						fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
// 					}}
// 				>
// 					{pageTitle}
// 				</div>
// 			</div>
// 		);
// 	};
// 	const headerSearch = renderHeader();
// 	return (
// 		<>
// 			<DataTable
// 				value={rows && rows}
// 				showGridlines
// 				resizableColumns
// 				columnResizeMode="expand"
// 				scrollable
// 				className="SkeletonLoadingDataGrid"
// 			>
// 				{columns && rows && (
// 					<Column
// 						selectionMode="multiple"
// 						hidden={!showChecboxColumn}
// 						frozen
// 						resizeable={false}
// 						style={{ width: "36px", textAlign: "center" }}
// 						field="selection"
// 						columnKey="selection"
// 						className="selectionHeader"
// 						headerClassName="selectionHeader"
// 						body={<Skeleton />}
// 					></Column>
// 				)}
// 				{rows && rows.length ? (
// 					<Column
// 						body={<Skeleton />}
// 						style={{ width: "36px" }}
// 						hidden={!showSettingColumn}
// 						resizeable={false}
// 						reorderable={false}
// 						frozen
// 						headerClassName="settingHeader"
// 					></Column>
// 				) : undefined}
// 				{rows && rows.length ? (
// 					<Column
// 						header="#"
// 						className="indexColumn"
// 						headerClassName="indexColumn"
// 						headerStyle={{ width: "24px" }}
// 						frozen
// 						hidden={!showIndexColumn}
// 						body={<Skeleton />}
// 					></Column>
// 				) : undefined}

// 				{columns &&
// 					columns.map((x: any, index: any) => (
// 						<Column
// 							key={index}
// 							field={x.field}
// 							header={x.headerName}
// 							body={<Skeleton />}
// 						/>
// 					))}

// 				{rows && rows.length ? (
// 					<Column
// 						body={<Skeleton />}
// 						hidden={!showSettingColumn}
// 						resizeable={false}
// 						reorderable={false}
// 						frozen
// 						alignFrozen="right"
// 						className="settingHeader"
// 						headerClassName="settingHeader"
// 					></Column>
// 				) : undefined}
// 			</DataTable>
// 		</>
// 	);
// };

import "./SkeletonLoadingDataGridStyle.css";

import React from "react";
import { Skeleton } from "primereact/skeleton";

const SKELETON_ROWS = 5;
const SKELETON_COLS = 8; // adjust to match your typical column count

export const SkeletonLoadingDataGrid: React.FC<{ pageTitle?: string }> = ({ pageTitle }) => {
	return (
		<div style={{ width: "100%", fontFamily: "'Roboto','Helvetica','Arial',sans-serif", margin: "14px 0.5rem 0.5rem 0" }}>

			{/* Header toolbar skeleton */}
			<div style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				paddingBottom: "1rem"
			}}>
				<div style={{
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}>{pageTitle}</div>
				<div style={{ display: "flex", gap: "8px" }}>
					<Skeleton width="180px" height="1.5rem" />
					<Skeleton width="300px" height="1.5rem" />
					<Skeleton width="80px" height="1.5rem" />
				</div>
			</div>

			{/* Table skeleton */}
			<div style={{ border: "1px solid #e0e0e0", borderRadius: "2px", overflow: "hidden" }}>

				{/* Column header row */}
				<div style={{
					display: "grid",
					gridTemplateColumns: `36px 36px 60px repeat(${SKELETON_COLS}, 1fr) 60px`,
					borderBottom: "2px solid #e0e0e0",
					background: "#f8f8f8",
					padding: "10px 8px",
					gap: "8px",
				}}>
					<Skeleton height="1rem" width="20px" />
					<Skeleton height="1rem" width="20px" />
					<Skeleton height="1rem" width="40px" />
					{Array.from({ length: SKELETON_COLS }).map((_, i) => (
						<Skeleton key={i} height="1rem" />
					))}
					<Skeleton height="1rem" width="40px" />
				</div>

				{/* Data rows */}
				{Array.from({ length: SKELETON_ROWS }).map((_, rowIndex) => (
					<div
						key={rowIndex}
						style={{
							display: "grid",
							gridTemplateColumns: `36px 36px 60px repeat(${SKELETON_COLS}, 1fr) 60px`,
							borderBottom: "1px solid #e0e0e0",
							padding: "10px 8px",
							gap: "8px",
							background: rowIndex % 2 === 0 ? "#ffffff" : "#fafafa",
						}}
					>
						<Skeleton height="1.2rem" width="20px" />
						<Skeleton height="1.2rem" width="20px" />
						<Skeleton height="1.2rem" width="40px" />
						{Array.from({ length: SKELETON_COLS }).map((_, colIndex) => (
							<Skeleton key={colIndex} height="1.2rem" />
						))}
						<Skeleton height="1.2rem" width="40px" />
					</div>
				))}
			</div>
		</div>
	);
};
